<template>
  <v-dialog max-width="400" v-model="show" persistent>
    <v-card class="primary-card">
      <v-card-title>Alterar senha</v-card-title>
      <v-card-text class="pt-5 pb-0">
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                v-model="form.currentPassword"
                label="Senha atual*"
                required
                :type="showCurrentPassword ? 'text' : 'password'"
                :rules="[fieldRules.required]"
                :append-inner-icon="showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showCurrentPassword = !showCurrentPassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12"
              class="pb-0">
              <v-text-field v-model="form.newPassword"
                label="Nova senha*"
                required
                :type="showNewPassword ? 'text' : 'password'"
                :rules="[fieldRules.required, fieldRules.minLength]"
                :append-inner-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showNewPassword = !showNewPassword"  
                maxlength="16"
              >
              <template v-slot:append-inner>
                <v-tooltip text="Deve ter entre 6 e 16 caracteres e incluir pelo menos uma maiúscula, uma minúscula, um número e um caractere especial" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="x-small" icon="mdi-help-circle" class="mr-1" />
                  </template>
                </v-tooltip>
              </template>
              </v-text-field>
            </v-col>
            <v-col cols="12"
              class="pb-5">
              <v-text-field v-model="form.confirmPassword"
                label="Repita a nova senha*"
                required
                :type="showConfirmPassword ? 'text' : 'password'"
                :rules="[fieldRules.required, fieldRules.minLength]"
                :append-inner-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showConfirmPassword = !showConfirmPassword"
                maxlength="16"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>
        <v-btn text="Cancelar" @click="close"></v-btn>
        <v-btn variant="flat" color="primary" text="Salvar" @click="save" :loading="submitLoading"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { fieldRules } from '@/utils/validationRules';
export default {
  name: 'passwordDialog',
  data() {
    return {
      show: true,
      submitLoading: false,
      fieldRules: {
        ...fieldRules,
        minLength: v => v && v.length >= 6 || 'Mínimo de 6 caracteres',
      },
      form: {},
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async save() {
      const validate = await this.$refs.form.validate();
      if (!validate.valid) return;

      this.submitLoading = true;
      this.$http({
        method: 'put',
        url: `/users/change-password`,
        data: this.form
      }).then(() => {
          this.$store.dispatch('showSuccessSnack', 'Senha alterada com sucesso');
          this.$emit('saved');
          this.close();
      }).catch((err) => {
        if (!err.intercepted) {
          this.$store.dispatch('showErrorSnack', 'Erro ao alterar senha');
        }
        this.submitLoading = false;
      });
    },
  },
  created() {
    
  }
}
</script>
<style scoped></style>